export var onFilterHandler = function (newState, action, previousState, instance, onFilter) {
    var previousFilter = previousState.filters.find(function (f) { return f.id === action.columnId; });
    if ((previousFilter === null || previousFilter === void 0 ? void 0 : previousFilter.value) != action.filterValue) {
        var filters = newState.filters.map(function (f) {
            var _a, _b;
            var column = instance === null || instance === void 0 ? void 0 : instance.allColumns.find(function (c) { return c.id === f.id; });
            return {
                id: f.id,
                value: f.value,
                fieldType: (_a = column === null || column === void 0 ? void 0 : column.fieldType) !== null && _a !== void 0 ? _a : 'text',
                filterType: (_b = column === null || column === void 0 ? void 0 : column.filter) !== null && _b !== void 0 ? _b : 'text',
            };
        });
        onFilter === null || onFilter === void 0 ? void 0 : onFilter(filters, newState);
    }
};
